import { render, staticRenderFns } from "./ViewPayrun.vue?vue&type=template&id=cb56e5ce&scoped=true"
import script from "./ViewPayrun.vue?vue&type=script&lang=js"
export * from "./ViewPayrun.vue?vue&type=script&lang=js"
import style0 from "./ViewPayrun.vue?vue&type=style&index=0&id=cb56e5ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb56e5ce",
  null
  
)

export default component.exports